import { classToValidate, Checkbox } from '@apia/validations';
import React from 'react';
import { TApiaApiField } from '../ApiaApiHandler';

export const ApiaApiCheckbox = (props: TApiaApiField) => {
  const element = React.useMemo(() => props.element, [props.element]);
  const className = React.useMemo(
    () =>
      element.class
        ? `handler__checkbox ${element.class}`
        : 'handler__checkbox',
    [element.class],
  );
  const validationRules = React.useMemo(
    () => ({
      required: element.mandatory,
      ...classToValidate(element.class),
    }),
    [element.class, element.mandatory],
  );
  const submitValueParser = React.useCallback(
    (value: boolean | string) => value === 'on' || value === true,
    [],
  );
  return (
    <Checkbox
      className={className}
      name={element.id || element.name}
      label={element.text}
      title={element.title || element.text}
      initialValue={String(element.selected) === 'true'}
      disabled={element.readonly || element.disabled}
      validationRules={validationRules}
      onChange={element.onChange}
      submitValueParser={submitValueParser}
    />
  );
};
